import ProfitAndLossReport from './_ProfitAndLossReport';

export default ProfitAndLossReport;
